<template>
  <el-timeline-item :timestamp="null" placement="top">
    <el-card
      class="message-item"
      :body-style="{ padding: '16px' }"
      v-loading="true"
    >
      <!-- Header - foto y nombre del usario creador -->
      <template #header>
        <div class="message-header flex justify-start align-center">
          <el-avatar
            size="medium"
            class="box"
            src="/static/images/avatar-2.jpg"
          ></el-avatar>
          <span class="box username strong black-text"> Loading </span>
        </div>
      </template>
      <!-- Body - Slide de image -->
      <div class="message-body">
        <template v-if="false">
          <el-carousel height="400px" :interval="6000">
            <el-carousel-item
              v-for="image in message.Images"
              :key="image.Id"
              class="flex justify-center content-center align-center"
            >
              <el-image :key="image.Src" :src="image.Src"></el-image>
            </el-carousel-item>
          </el-carousel>
        </template>

        <div class="commentary-box">
          <div aria-label="seperator" class="separator-bottom"></div>
          <div class="commentary-tools">
            <span class="commentary-tool">
              <div
                aria-label="Me gusta"
                class="commentary-button w-100"
                role="button"
                tabindex="0"
              >
                <div
                  class="_18vj"
                  :style="{ color: false ? '#2078f4' : 'inherit' }"
                >
                  <span class="mr-6">
                    <i class="mdi mdi-thumb-up-outline"></i>
                  </span>
                  Me gusta
                </div>
              </div>
            </span>

            <span class="commentary-tool b-two">
              <div
                aria-label="Dejar un comentario"
                class="commentary-button w-100"
                role="button"
                tabindex="0"
              >
                <div class="_18vj">
                  <span class="mr-6">
                    <i class="el-icon-chat-dot-round"></i>
                  </span>
                  Comentar
                </div>
              </div>
            </span>
          </div>

          <div class="commentary-list">
            <div aria-label="seperator" class="separator-top"></div>
            <ul>
              <comment-item
                v-for="commentary in comments"
                :key="commentary.Id"
                :comment="commentary"
              />
            </ul>
          </div>
        </div>
      </div>
    </el-card>
  </el-timeline-item>
</template>

<script>
export default {
  name: "LoadingMessage",
  data() {
    return {
      comments: [],
      message: {}
    };
  }
};
</script>

<style></style>
